import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import locale from '@angular/common/locales/nl';
import { provideGoogleTagManager } from 'angular-google-tag-manager';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json');

registerLocaleData(locale);

const GTM_ID_PROD = 'GTM-W8VWVRTQ';
const GTM_ID_DEV = 'GTM-P25G2JQC';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(),
    provideTranslateService({
      defaultLanguage: 'nl',
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideAnimations(),
    provideGoogleTagManager({
      id: GTM_ID,
      // gtm_csp_none: 'CSP-NONCE',
    }),
    { provide: LOCALE_ID, useValue: 'nl-NL' },
  ],
};
